<!-- 弹窗组件 -->
<template>
  <el-dialog v-loading="loading" :custom-class="customClass" v-bind="$attrs" v-on="$listeners" :close-on-click-modal="false"
    :close-on-press-escape="false" :destroy-on-close="true" :title="title" :width="dialogWidth" append-to-body>
    <slot></slot>
    <div v-if="showFooter && !footerCenter" slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">{{ submitText }}</el-button>
      <el-button @click="cancel">{{ cancelText }}</el-button>
    </div>
    <div v-if="showFooter && footerCenter" slot="footer" class="dialog-footer-center">
      <el-button @click="cancel">{{ cancelText }}</el-button>
      <el-button type="primary" @click="submit">{{ submitText }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'customDialog',
  // 定义引入的组件
  components: {},
  props: {
    title: {
      type: String,
      default: "",
    },
    /**
     * @description: 底部按钮布局是否居中
     * @return {*}
     */
    footerCenter: {
      type: Boolean,
      default: false,
    },
    // 是否显示title
    titleShow: {
      type: Boolean,
      default: false,
    },
    // 是否显示按钮
    showFooter: {
      type: Boolean,
      default: true,
    },
    // 确定按钮文字
    submitText: {
      type: String,
      default: "确 定",
    },
    // 取消按钮文字
    cancelText: {
      type: String,
      default: "取 消",
    },
    dialogWidth:{
      type:String,
      default:'50%'
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {};
  },
  //变量监听
  watch: {},
  computed: {
    customClass() {
      return this.titleShow ? "no-title-customDialog" : "";
    },
  },
  // 页面初始化
  created() { },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    /**
     * @description:确定按钮
     * @return {*}
     */
    submit() {
      this.$emit("submit");
    },
    /**
     * @description: 取消按钮
     * @return {*}
     */
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>
<style lang="less" >
.no-title-customDialog {
  .el-dialog__title {
    display: inline-block;
    height: 20px;
    opacity: 0;
  }
}

.dialog-footer-center {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>